import {useMe} from '@/features/authentication/queries/useMe'
import {ChannelsTypesE} from '@/features/chat/chat.model'
import {useGetChannelsListV3} from '@/features/chat/queries/useGetChannelsListV3'
import {generateChatChannelName, getCorrectUserId} from '@/utilities/helpers'

export const useGetConnectedUser = (userId?: number) => {
    const {data} = useMe()
    const correctUserId = data ? getCorrectUserId(data) : undefined
    const {data: channels} = useGetChannelsListV3({
        channelStatus: ChannelsTypesE.ACTIVE,
        limit: 100,
        representedCreatorId: String(correctUserId)
    })
    const allChannels = channels?.pages.flatMap(page => page.channelsList) ?? []
    const channelId = !!data && !!userId && generateChatChannelName(+data.id, data.type, userId)
    const connectedUser = !!channelId && allChannels?.length && allChannels.find(({pk}) => pk === channelId)

    return {connectedUser, channelId}
}
